import { useFlags } from 'launchdarkly-react-client-sdk'

import CenterPanel from '../../components/layout/CenterPanel'
import { useSelectedComponentElement } from '../../hooks'

import BriefAnalysisPage from './BriefAnalysis'
import BriefPage from './BriefPage'

type Props = {
  isWebsocketLoading: boolean
}

const CenterSection = ({ isWebsocketLoading }: Props) => {
  const { data: selectedElement } = useSelectedComponentElement()
  const flags = useFlags()

  return (
    <CenterPanel>
      {flags.showBriefAnalysis ? (
        <BriefAnalysisPage
          key={selectedElement?.element_id || 'brief-analysis'}
          isWebsocketLoading={isWebsocketLoading}
        />
      ) : (
        <BriefPage
          key={selectedElement?.element_id || 'brief'}
          isWebsocketLoading={isWebsocketLoading}
        />
      )}
    </CenterPanel>
  )
}

export default CenterSection
